import axios from 'axios';

export const saveSaleRoomOnWebsite = (branchID, data, token) => {
    let newURL = "/sale_room/" + branchID + "/save_sale_room_on_website"
    return axios.post(`${newURL}`, data, {
        headers: { Authorization: token }
    });
}

export const getSaleRoomOnWebsite = (branchID, month, token) => {
    let newURL = "/sale_room/" + branchID + "/get_sale_room_on_website?month=" + encodeURIComponent(month)
    return axios.get(`${newURL}`, {
        headers: { Authorization: token }
    });
}